import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getData,
  postData,
} from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import moment from "moment";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Card,
  CardBody,
} from "reactstrap";
import { fas } from "@fortawesome/free-solid-svg-icons";

const Expenses: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { month, employeeId, dropdownLabel, totalExpenseAmount } =
    location.state || {};
  console.log(
    month,
    employeeId,
    dropdownLabel,
    totalExpenseAmount,
    "=========params"
  );

  const [expenseData, setExpenseData] = useState<any[]>([]);
  const [statusMap, setStatusMap] = useState<Record<number, string>>({});
  const [loading, setLoading] = useState<boolean>(true); // Added loading state
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});
  const [toBeVerifiedExpenses, setToBeVerifiedExpenses] = useState<any[]>([]);
  const [expIdList, setExpIdList] = useState<string>("");
  const [varifiedExpenses, setVarifiedExpenses] = useState<
    Record<string, string[]>
  >({});
  const [workingDays, setWorkingDays] = useState<number | null>(null);
  const [totalExpCount, setTotalExpCount] = useState(0);
  const [totalExpenseAmountFromApi, setTotalExpenseAmountFromApi] =
    useState<number>(0);
  const [canSubmit, setCanSubmit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rejectionRemark, setRejectionRemark] = useState("");

  const [lastDates, setLastDates] = useState({
    LastSubmittedDate: null,
    LastApprovedDate: null,
    LastAuditedDate: null,
  });

  const serverUrl = localStorage.getItem("serverUrl");
  const userEmp = localStorage.getItem("empId");

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        setLoading(true); // Set loading to true before fetching data
        const url = `${serverUrl}${API.getExpensesNew}`;
        const params = {
          month: `${Object.keys(month || {})[0]}`,
          employee: employeeId,
        };
        const { status, data } = await postData(url, true, params);

        if (status === 200) {
          const formattedData = Object.entries(data.data.data).map(
            ([key, value]: [string, any]) => ({
              date: key, // Use the key as the date
              ...value,
            })
          );
          setExpenseData(formattedData);
          setTotalExpCount(data?.data?.expensecount);
          // compute total expense amount from the response
          try {
            const total = formattedData.reduce((acc, item) => {
              // Prefer explicit total field
              if (item?.expenses?.ExpenseFinalAmt != null) {
                const v = Number(item.expenses.ExpenseFinalAmt) || 0;
                return acc + v;
              }
              if (item?.TotalExpenseAmount != null) {
                const v = Number(item.TotalExpenseAmount) || 0;
                return acc + v;
              }
              // Fall back to summing expenseLine amounts
              if (
                Array.isArray(item.expenseLine) &&
                item.expenseLine.length > 0
              ) {
                const sumLine = item.expenseLine.reduce(
                  (s: number, line: any) =>
                    s + (Number(line.ExpFinalAmount) || 0),
                  0
                );
                return acc + sumLine;
              }
              return acc;
            }, 0);
            setTotalExpenseAmountFromApi(total);
          } catch (err) {
            console.error("Error computing total expense amount:", err);
            setTotalExpenseAmountFromApi(0);
          }
          console.log("Formatted Expenses:data", data.data);
        } else {
          console.error("Failed to fetch expenses.");
        }
      } catch (error) {
        console.error("Error fetching expenses:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    const fetchStatusMap = async () => {
      try {
        const url = `${serverUrl}${API.getStatus}`;
        // console.log('Fetching Status Map from:', url); // Log the URL
        const { status, data } = await getData(url, true);
        // console.log('Raw Response:', { status, data }); // Log the raw response

        if (status === 200 && data.data[0]?.Expenses) {
          const parsedStatusMap = Object.keys(data.data[0].Expenses).reduce(
            (acc, key) => {
              acc[parseInt(key, 10)] = data.data[0].Expenses[key];
              return acc;
            },
            {} as Record<number, string>
          );
          setStatusMap(parsedStatusMap);
          // console.log('Fetched Status Map:', parsedStatusMap); // Log the status map
        } else {
          console.error(
            "Failed to fetch status map. Status:",
            status,
            "Data:",
            data
          );
        }
      } catch (error) {
        console.error("Error fetching status map:", error);
      }
    };

    fetchExpenses();
    fetchStatusMap();
  }, [month, employeeId, serverUrl]);

  useEffect(() => {
    const lengthOfToBeVerifiedExp = expenseData?.filter(
      (item) =>
        item?.expenses?.DoVerify === true &&
        !varifiedExpenses[item?.expenses?.ExpId]?.includes(
          item?.expenses?.ExpenseDate
        )
    );
    setToBeVerifiedExpenses(lengthOfToBeVerifiedExp);
    console.log("To be verified expenses:", lengthOfToBeVerifiedExp);
  }, [expenseData, varifiedExpenses]);

  const handleCheckboxSelection = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => {
    const checked = event.target.checked;

    if (checked) {
      let emp = expenseData?.filter(
        (item) => item?.expenses?.Employee?.EmployeeId
      );
      console.log(
        "Filtered Employee:",
        emp,
        emp[0]?.expenses?.Employee?.EmployeeId,
        userEmp,
        "==========="
      );

      if (emp[0]?.expenses?.Employee?.EmployeeId === userEmp) {
        let fData = expenseData?.filter(
          (item) =>
            item?.expenses?.ExpenseStatus === 1 ||
            item?.expenses?.ExpenseStatus === 4
        );
        if (fData?.length > 0) {
          const newExpIds = fData
            .map((item) => item?.expenses?.ExpId.toString())
            .join(",");
          setExpIdList(newExpIds);
          console.log("Selected Expense IDs:", newExpIds);
        }
      } else {
        let lengthOfToBeVerifiedExp = expenseData?.filter(
          (item) =>
            item?.expenses?.DoVerify === true &&
            !varifiedExpenses[item?.expenses?.ExpId]?.includes(
              item?.expenses?.ExpenseDate
            )
        )?.length;

        if (lengthOfToBeVerifiedExp > 0) {
          toast.warning(
            "Sorry, there are some expenses which need to be validated."
          );
          return;
        }
        const newExpIds = expenseData
          ?.filter(
            (item) =>
              item?.expenses?.DoVerify === false ||
              (item?.expenses?.DoVerify === true &&
                varifiedExpenses[item?.expenses?.ExpId]?.includes(
                  item?.expenses?.ExpenseDate
                ))
          )
          .map((item) => item?.expenses?.ExpId?.toString())
          .join(",");
        setExpIdList(newExpIds);
      }
    } else {
      setExpIdList("");
    }

    // Select all rows if any row or header checkbox is selected
    const newSelectedRows: Record<number, boolean> = {};
    if (checked) {
      expenseData.forEach((_, idx) => {
        newSelectedRows[idx] = true;
      });
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
    setSelectedRows(newSelectedRows);
  };

  useEffect(() => {
    if (expenseData.length > 0) {
      addToVarifiedExpenses();
    }
  }, [expenseData]);
  console.log(
    varifiedExpenses,
    expIdList,
    expIdList.length,
    "========================================"
  );

  const headData = [
    {
      id: "select",
      head: (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={(event) => handleCheckboxSelection(event)}
        />
      ),
      key: "select",
    },
    { id: "date", head: "Expense Date", key: "date", sortKey: "date" },
    {
      id: "totalCalls",
      head: "Total Calls",
      key: "TotalCalls",
      sortKey: "TotalCalls",
    },
    { id: "totalNCAs", head: "Total NCA's", key: "NCA", sortKey: "NCA" },
    {
      id: "type",
      head: "Type",
      key: "expenses.TripType",
      sortKey: "expenses.TripType",
    },
    {
      id: "placeOfWork",
      head: "Place Of Work",
      key: "expenses.ExpensePlacewrk",
      sortKey: "expenses.ExpensePlacewrk",
    },
    { id: "ta", head: "TA", key: "ta", sortKey: "ta" },
    { id: "da", head: "DA", key: "da", sortKey: "da" },
    {
      id: "otherExpense",
      head: "Other Expense",
      key: "otherExpense",
      sortKey: "otherExpense",
    },
    {
      id: "totalExpense",
      head: "Total Expense",
      key: "expenses.ExpenseFinalAmt",
      sortKey: "expenses.ExpenseFinalAmt",
    },
    {
      id: "status",
      head: "Status",
      key: "expenses.ExpenseStatus",
      sortKey: "expenses.ExpenseStatus",
    },
  ];

  const handleViewClick = (
    expId: string,
    doVerify: boolean,
    expenseStatus?: number | string
  ) => {
    console.log(expenseStatus, "========item.expenses?.ExpenseStatus");

    navigate("/expenses/expenseoverview", {
      state: { expId, doVerify, expenseStatus },
    });
  };

  const renderRow = (item: any, index: number) => {
    const ta =
      item.expenseLine?.find((line: any) =>
        line.ExpenseMaster?.ExpenseName?.toLowerCase().includes("ta")
      )?.ExpFinalAmount || 0;
    const da =
      item.expenseLine?.find((line: any) =>
        line.ExpenseMaster?.ExpenseName?.toLowerCase().includes("da")
      )?.ExpFinalAmount || 0;
    const otherExpense = item.expenses?.ExpenseFinalAmt - (ta + da);
    let type = item?.hasOwnProperty("Type");
    let shouldValidated =
      item?.expenses?.DoVerify &&
      !varifiedExpenses.hasOwnProperty(item.expenses.ExpId);
    const expenseStatus = Number(item.expenses?.ExpenseStatus);
    const status = statusMap[expenseStatus] || "-";

    const statusColors: Record<number, string> = {
      1: "#ff8400ff",
      2: "#1c65d3",
      3: "#6cbb33ff",
      4: "#ff0000ff",
      5: "#ffa500ff",
      6: "#800080ff",
      7: "#a52a2aff",
      8: "#008080ff",
      9: "#f96c6cff",
      10: "#0400ffff",
      11: "#009400ff",
    };

    const statusColor = statusColors[expenseStatus] || "black";

    const getRowColor = (item: any) => {
      if (item?.expenses?.DoVerify && item?.FW < 4) {
        return "#F8EA8C";
      }
      if (item?.expenses?.DoVerify) {
        return "#F8EA8C";
      }
      if (item?.WeekOff || item?.Holiday || item?.Leave) {
        return "#ADD8E6";
      }
      if (item?.FW < 4 || (item?.NCA > 0 && item?.FW > 0)) {
        return "#F9BDC0";
      }
      return "white";
    };

    return (
      <tr key={index} style={{ backgroundColor: getRowColor(item) }}>
        <td style={{ paddingLeft: 10 }}>
          {!type && !shouldValidated && (
            <input
              type="checkbox"
              checked={!!selectedRows[index]}
              onChange={(event) => handleCheckboxSelection(event, index)}
            />
          )}
        </td>
        <td style={{ paddingLeft: 10 }}>
          {moment(item.date, "YYYY-MM-DD").format("DD MMM")}
        </td>
        <td style={{ paddingLeft: 10 }}>{item.TotalCalls || "-"}</td>
        <td style={{ paddingLeft: 10 }}>{item.NCA || "-"}</td>
        <td style={{ paddingLeft: 10 }}>{item.expenses?.TripType || "-"}</td>
        <td style={{ paddingLeft: 10 }}>
          {item.expenses?.ExpensePlacewrk || "-"}
        </td>
        <td style={{ paddingLeft: 10 }}>{ta}</td>
        <td style={{ paddingLeft: 10 }}>{da}</td>
        <td style={{ paddingLeft: 10 }}>{otherExpense || "-"}</td>
        <td style={{ paddingLeft: 10 }}>
          {item.expenses?.ExpenseFinalAmt || "-"}
        </td>
        <td style={{ paddingLeft: 10, color: statusColor }}>
          {!type ? status : item.Day || "-"}
        </td>
        <td style={{ paddingLeft: 10 }}>
          <button
            className="btn btn-primary"
            onClick={() =>
              handleViewClick(
                item.expenses?.ExpId,
                item.expenses?.DoVerify,
                item.expenses?.ExpenseStatus
              )
            }
          >
            View
          </button>
        </td>
      </tr>
    );
  };

  const selectAllCheck = async (checked: boolean) => {
    try {
      // selectAllCustomer(checked);
      if (checked) {
        let emp = expenseData?.filter(
          (item) => item?.expenses?.Employee?.EmployeeId
        );

        if (emp[0]?.expenses?.Employee?.EmployeeId === userEmp) {
          let fData = expenseData?.filter(
            (item) =>
              item?.expenses?.ExpenseStatus === 1 ||
              item?.expenses?.ExpenseStatus === 4
          );
          if (fData?.length > 0) {
            const newExpIds = fData
              .map((item) => item?.expenses?.ExpId.toString())
              .join(",");
            setExpIdList(newExpIds);
          }
        } else {
          let lengthOfToBeVerifiedExp = expenseData?.filter(
            (item) =>
              item?.expenses?.DoVerify === true &&
              !varifiedExpenses[item?.expenses?.ExpId]?.includes(
                item?.expenses?.ExpenseDate
              )
          )?.length;
          // props.setToBeVarifiedLength(lengthOfToBeVerifiedExp);
          if (lengthOfToBeVerifiedExp > 0) {
            toast.warning(
              "Sorry, there are some expenses which need to be validated."
            );
            return;
          }
          const newExpIds = expenseData
            ?.filter(
              (item) =>
                item?.expenses?.DoVerify === false ||
                (item?.expenses?.DoVerify === true &&
                  varifiedExpenses[item?.expenses?.ExpId]?.includes(
                    item?.expenses?.ExpenseDate
                  ))
            )
            .map((item) => item?.expenses?.ExpId?.toString())
            .join(",");
          setExpIdList(newExpIds);
        }
      } else {
        setExpIdList("");
      }
    } catch (err) {
      console.error("Error in selectAllCheck:", err);
    }
  };

  const addToVarifiedExpenses = () => {
    const newVarifiedExpenses: Record<string, string[]> = {};
    expenseData.forEach((item) => {
      if (item?.expenses?.ExpId && item?.expenses?.ExpenseDate) {
        newVarifiedExpenses[item.expenses.ExpId] = [item.expenses.ExpenseDate];
      }
    });
    setVarifiedExpenses((prev) => ({
      ...prev,
      ...newVarifiedExpenses,
    }));
    console.log("Varified Expenses Updated:", newVarifiedExpenses);
  };

  const fetchWorkingDays = async () => {
    try {
      const url = `${serverUrl}${API.getWorkingDays}`;
      const formattedMonth = moment(
        Object.keys(month || {})[0],
        "YYYY-MM-DD"
      ).format("MM-YYYY");
      const params = { employee_id: employeeId, month: formattedMonth };
      const { status, data } = await getData(url, true, params);
      console.log("Fetched Working Days:", data);
      if (status === 200) {
        setWorkingDays(data?.data?.WorkingDays);
      } else {
        console.error("Failed to fetch working days.");
      }
    } catch (error) {
      console.error("Error fetching working days:", error);
    }
  };

  useEffect(() => {
    if (employeeId && month) {
      fetchWorkingDays();
    }
    // const selecteddt = moment(month.split('|')[0], 'YYYY-MM-DD');
    //   const validatedt = selecteddt.add(1, 'month').startOf('month');
    //   const currentdt = moment().startOf('month');

    //   const difference = currentdt.diff(validatedt, 'months');
    //   setCanSubmit(difference >= 0);
  }, [employeeId, month]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const submitExpense = async (action: number, rejectionNote: string) => {
    try {
      const url = `${serverUrl}${API.expensesApproved}`;
      const params = {
        ExpId: expIdList,
        status: action,
        note: action === 4 ? rejectionNote : "",
      };
      const { status, data } = await postData(url, true, params);
      console.log("Response:", data);
      if (status === 200) {
        toast.success(data.message || "Expense submitted successfully!");
      } else {
        toast.error(data.message || "Failed to submit expense.");
      }
    } catch (error) {
      console.error("Error submitting expense:", error);
      toast.error("An error occurred while submitting the expense.");
    } finally {
      // toggleModal();
    }
  };

  useEffect(() => {
    const fetchLastDates = async () => {
      try {
        const url = `${serverUrl}${API.getExpenseLastDates}`;
        const formattedMonth = `${Object.keys(month || {})[0]}`;
        const params = { employee_id: employeeId, month: formattedMonth };
        const { status, data } = await getData(url, true, params);

        if (status === 200) {
          console.log("Fetched Last Dates:", data);
          setLastDates(data.data);
        } else {
          console.error("Failed to fetch last dates.");
        }
      } catch (error) {
        console.error("Error fetching last dates:", error);
      }
    };

    if (employeeId && month) {
      fetchLastDates();
    }
  }, [employeeId, month]);

  return (
    <div style={{ padding: "20px" }} className="page-body p-2">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CardHeaderSpan
          headingClassName="p-2"
          back={true}
          heading={`Expense of ${dropdownLabel} `}
          span={"ReportListTitle"}
        />
        {userEmp !== employeeId &&
          totalExpCount >= (workingDays || 0) &&
          toBeVerifiedExpenses.length < 1 &&
          Object.values(expIdList).length > 0 && (
            <>
              <button
                className="btn btn-primary"
                style={{ marginRight: "10px" }}
                onClick={() => submitExpense(3, "")}
              >
                Approve
              </button>
            </>
          )}
      </div>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
        }}
      > */}

      {/* <span>To Be Verified: {toBeVerifiedExpenses.length}</span> */}
      <div className="row g-2">
        <div className="col-lg-2 col-md-6 col-sm-12">
          <Card
            style={{
              minHeight: "90px",
              border: "1px solid #ddd",
              backgroundColor: "#fff",
            }}
          >
            <CardBody
              style={{
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6
                  style={{
                    fontSize: "0.9rem",
                    color: "#888",
                    marginBottom: "4px",
                  }}
                >
                  Total Expenses
                </h6>
                <h3 style={{ fontSize: "1rem", margin: 0, fontWeight: 600 }}>
                  {/* {totalExpCount} */}₹{" "}
                  {totalExpenseAmountFromApi || totalExpenseAmount || "0"}
                </h3>
              </div>
            </CardBody>
          </Card>
        </div>

        <div className="col-lg-2 col-md-6 col-sm-12">
          <Card
            style={{
              minHeight: "90px",
              border: "1px solid #ddd",
              backgroundColor: "#fff",
            }}
          >
            <CardBody
              style={{
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6
                  style={{
                    fontSize: "0.9rem",
                    color: "#888",
                    marginBottom: "4px",
                  }}
                >
                  Working Days
                </h6>
                <h3 style={{ fontSize: "1rem", margin: 0, fontWeight: 600 }}>
                  {workingDays || "-"}
                </h3>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Last Dates Cards */}
        {(
          ["LastSubmittedDate", "LastApprovedDate", "LastAuditedDate"] as Array<
            keyof typeof lastDates
          >
        ).map(
          (key) =>
            lastDates[key] && (
              <div className="col-lg-2 col-md-6 col-sm-12" key={key}>
                <Card
                  style={{
                    minHeight: "90px",
                    border: "1px solid #ddd",
                    backgroundColor: "#fff",
                  }}
                >
                  <CardBody
                    style={{
                      padding: "12px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <h6
                        style={{
                          fontSize: "0.9rem",
                          color: "#888",
                          marginBottom: "4px",
                        }}
                      >
                        {key.replace("Last", "").replace("Date", "")}
                      </h6>
                      <h3
                        style={{
                          fontSize: "1rem",
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        {moment(lastDates[key]).format("DD MMM YYYY")}
                      </h3>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )
        )}
      </div>

      {/* <div>
          <button className="btn btn-success" style={{ marginRight: '10px' }}>Approve</button>
          <button className="btn btn-danger">Reject</button>
          </div> */}
      {/* {userEmp == employeeId &&
            totalExpCount >= (workingDays || 0) &&
            Object.values(expIdList).length > 0 && (
              <>
                <button
                  className="btn btn-info"
                  style={{ marginRight: "10px" }}
                  onClick={toggleModal}
                >
                  Submit
                </button>
              </>
            )} */}

      {/* </div> */}
      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Are you sure you want to submit this expense?
        </ModalHeader>
        <ModalBody>
          <Input
            type="text"
            placeholder="Enter your remark"
            value={rejectionRemark}
            onChange={(e) => setRejectionRemark(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => submitExpense(2, rejectionRemark)}
          >
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {loading ? (
        <div className="text-center py-3">
          <div>
            <Image
              className="b-r-10 img-80"
              src={dynamicImage("dashboard/loader.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      ) : (
        <div className="px-2">
          <CommonTableNew
            tableClass="table caption"
            strip={false}
            caption=""
            size="sm"
            hover
            headData={headData}
            data={expenseData}
            renderRow={renderRow}
            initialRows={35} // Show 35 rows initially
          />
        </div>
      )}
    </div>
  );
};

export default Expenses;
